import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import AgGrid from '../shared/agGrid/agGrid.component';
import getColumnDefinitions from '../shared/columnDefinitions/userSettings';
import { confirmModalDataPropTypes } from '../shared/propTypes';
import { UserPropTypes } from '../shared/propTypes/users';
import { filterUsers } from './utils';
import { fetchUser } from './api';

const newUserRow = {
  email: '',
  firstName: '',
  lastName: '',
  sso: '',
  activeFlag: '',
  clients: '',
};

class UsersGrid extends PureComponent {
  static propTypes = {
    users: PropTypes.arrayOf(UserPropTypes.isRequired),
    componentToRenderOnSearchBar: PropTypes.node.isRequired,
    currentlySelectedSso: PropTypes.string,
    showUserSettingsFormForView: PropTypes.func.isRequired,
    onUsersGridReady: PropTypes.func.isRequired,
    addingNewUser: PropTypes.bool.isRequired,
    isUserModified: PropTypes.bool.isRequired,
    isGridLoading: PropTypes.bool.isRequired,
    confirmDialogData: confirmModalDataPropTypes,
    showConfirmDialogModal: PropTypes.func.isRequired,
    hideConfirmDialogModal: PropTypes.func.isRequired,
    openFormForEdit: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool.isRequired,
    loggedInUserSso: PropTypes.string.isRequired,
    canEditHimself: PropTypes.bool.isRequired,
    canEditUsers: PropTypes.bool.isRequired,
    confirmModalData: confirmModalDataPropTypes,
    showUserSettingsFormForEdit: PropTypes.func.isRequired,
    userToEditSso: PropTypes.string,
    canAddUser: PropTypes.bool.isRequired,
  };

  state = {
    rowData: [],
    isDataLoading: true,
  };

  async componentDidMount() {
    await this.updateRowData();
  }

  async componentDidUpdate(prevProps) {
    const { addingNewUser, users } = this.props;
    const { addingNewUser: prevAddingNewUser, users: prevUsers } = prevProps;

    if (addingNewUser && !prevAddingNewUser) {
      this.api.setQuickFilter('');

      const topRow = this.api.getModel().getRow(0);

      if (topRow) {
        const deselectOthers = true;
        topRow.setSelected(true, deselectOthers);
      }
    }

    if (prevUsers !== users) {
      await this.updateRowData();
    }
  }

  updateRowData = async () => {
    const { loggedInUserSso, users, addingNewUser } = this.props;
    const loggedUser = await fetchUser(loggedInUserSso);
    const filteredUsers = filterUsers(loggedUser.user.email || '', users);

    const rowData = addingNewUser && newUserRow.email !== '' ? [newUserRow, ...filteredUsers] : filteredUsers;

    this.setState({ rowData, isDataLoading: false });
  };

  onGridReady = params => {
    this.api = params.api;
    this.props.onUsersGridReady(params);
  };

  onCellClicked = event => {
    if (event.column.colId === 'sso') {
      return;
    }

    const {
      currentlySelectedSso,
      isUserModified,
      showUserSettingsFormForView,
      showConfirmDialogModal,
    } = this.props;

    const clickedRowSso = event.data.sso;

    if (isUserModified) {
      this.api.forEachNode(node => {
        if (node.data.sso === currentlySelectedSso && !node.data.selected) {
          node.setSelected(true);
        }
      });

      showConfirmDialogModal({ onConfirm: this.onModalConfirm, ssoToBeSelected: clickedRowSso });

      return;
    }

    showUserSettingsFormForView(clickedRowSso);
  };

  onModalConfirm = () => {
    const { showUserSettingsFormForView, confirmDialogData, hideConfirmDialogModal } = this.props;

    showUserSettingsFormForView(confirmDialogData.data.ssoToBeSelected);

    hideConfirmDialogModal();
  };

  render() {
    const {
      componentToRenderOnSearchBar,
      addingNewUser,
      isGridLoading,
      openFormForEdit,
      readOnly,
      canEditHimself,
      canEditUsers,
      loggedInUserSso,
      isUserModified,
      confirmModalData,
      userToEditSso,
      showUserSettingsFormForEdit,
      showConfirmDialogModal,
      hideConfirmDialogModal,
      canAddUser,
    } = this.props;

    const { rowData, isDataLoading } = this.state;

    const columnDefs = getColumnDefinitions({
      addingNewUser,
      canEditHimself,
      canEditUsers,
      loggedInUserSso,
      isUserModified,
      confirmModalData,
      userToEditSso,
      readOnly,

      showUserSettingsFormForEdit,
      showConfirmDialogModal,
      hideConfirmDialogModal,
    });

    return (
      <div className="users-grid page-content-container">
        <AgGrid
          componentToRenderOnSearchBar={canAddUser && componentToRenderOnSearchBar}
          rowData={isGridLoading || isDataLoading ? [] : rowData}
          columnDefs={columnDefs}
          withSearchBar
          disableSearchBar={addingNewUser}
          rowMultiSelectWithClick={false}
          onGridReady={this.onGridReady}
          onCellClicked={this.onCellClicked}
          isGridLoading={isGridLoading}
          isScrollDisabled={openFormForEdit && !readOnly}
        />
      </div>
    );
  }
}

export default UsersGrid;
